import { TransactionSummaryService } from './transaction-summary.service';
import { ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { Dictionary } from '../../models/dictionary.model';
import { SummaryFormatStrings } from './summary-format-strings.class';
import { Jurisdiction } from '../../../foundation/models/enums/jurisdiction.enum';
import { OwnershipRoleType } from '../../../titleregistration/models/enums/ownership-role-type.enum';
import { LegalStatusType } from '../../../titleregistration/models/enums/legal-status-type.enum';
import { BusinessTransactionType } from '../../../foundation/models/enums/business-transaction-type.enum';
import { OwnershipCustomerRelationshipModel } from '../../../titleregistration/models/ownership-customer-relationship.model';
import { HomemadeVehicleModel } from '../../../vehicle/models/homemade-vehicle.model';
import { HomemadeVehiclePermitTransactionModel } from '../../../titleregistration/models/HomemadeVehiclePermitTransactionModel';
import { Injectable } from '@angular/core';

@Injectable()
export class TitleRegistrationTransactionSummaryService extends TransactionSummaryService {
    private jurisdiction: Jurisdiction = new Jurisdiction();
    private ownershipRoleType: OwnershipRoleType = new OwnershipRoleType();
    private legalStatusType: LegalStatusType = new LegalStatusType();
    private businessTransactiontType: BusinessTransactionType = new BusinessTransactionType();

    public get sourceSystemType(): ISourceSystemType {
        return this.sourceSystemTypes.TitleRegistration;
    }

    public parseTransaction(transactionObject: any, transactionTypeId: number) {
        const summary: any[] = new Array<any>();

        const ownershipInfo: Dictionary = new Dictionary([]);
        const vehicleInfo: Dictionary = new Dictionary([]);
        let vehicleOwnership = null;
        const permitVehicle = null;
        let vehiclePlate = null;

        if (transactionObject.title) {
            vehicleOwnership = transactionObject.title.vehicleOwnership;
        } else if (transactionObject.registration) {
            vehiclePlate = transactionObject.registration.vehicleOwnershipPlate;
            vehicleOwnership = transactionObject.registration.vehicleOwnershipPlate.vehicleOwnership;
        } else if (transactionObject.vehicleOwnership) {
            vehicleOwnership = transactionObject.vehicleOwnership;
        }

        if (vehicleOwnership) {
            let ownerString = '';

            let customerName = '';
            let customerAddress = '';
            let city = '';
            let state = '';
            let zipCode = '';
            let dlNumber = 'No DL# Found';
            let owners = <OwnershipCustomerRelationshipModel[]> vehicleOwnership.ownershipCustomerRelationships.filter(c => c.ownershipRoleTypeID !== this.ownershipRoleType.Lienholder.id).sort((n1, n2) => n1.ownershipRoleSequence - n2.ownershipRoleSequence);
            let priorCustomerLegalStatusTypeID = 0;
            for (var i = 0; i < owners.length; i++) {
                const owner = owners[i];

                if (null == owner.customer) {
                    continue;
                }

                customerName = owner.customer.customerName;
                let address = owner.customer.mailingAddress;
                if (!address) {
                    address = owner.customer.physicalAddress;
                }
                /* if (null == address) {
                    address = owner.customer.customerAddresses[0];
                }*/

                if (address !== null) {
                    customerAddress = address.addressLine1;
                    city = address.city;
                    if (null != address.jurisdictionId) {
                        state = this.jurisdiction.FromId(address.jurisdictionId).code;
                    }

                    zipCode = address.postalZipCode;
                }

                if (null != owner.customer.driversLicenseNumber) {
                    dlNumber = owner.customer.driversLicenseNumber;
                } else {
                    dlNumber = 'No DL# Found';
                }

                if (ownerString !== '') {
                    if (priorCustomerLegalStatusTypeID === this.legalStatusType.And.id) {
                        ownerString += SummaryFormatStrings.AndRelationFormat;
                    } else if (priorCustomerLegalStatusTypeID === this.legalStatusType.Or.id) {
                        ownerString += SummaryFormatStrings.OrRelationFormat;
                    } else if (priorCustomerLegalStatusTypeID === this.legalStatusType.AndOr.id) {
                        ownerString += SummaryFormatStrings.AndOrRelationFormat;
                    } else if (priorCustomerLegalStatusTypeID !== 0) {
                        ownerString += SummaryFormatStrings.BlankRelationFormat;
                    }
                }

                priorCustomerLegalStatusTypeID = owner.legalStatusTypeID;

                ownerString += this.format(SummaryFormatStrings.VehicleOwnershipFormat, [customerName, dlNumber, customerAddress, city, state, zipCode]);
            }

            let vin = '';
            let year = '';
            let make = '';
            let model = '';
            let plate = '';
            let vehicle = null;
            if (transactionObject.vehicle) {
                vehicle = transactionObject.vehicle;
            } else {
                vehicle = vehicleOwnership.vehicle;
            }

            if (vehicle) {
                vin = vehicle.vin;
                year = vehicle.modelYear;
                make = vehicle.makeDisplayValue;
                model = vehicle.modelDisplayValue;
            }

            if (vehiclePlate && vehiclePlate.plate) {
                plate = vehiclePlate.plate.plateNumber;
            }

            if (transactionTypeId === this.businessTransactiontType.ManageLiensandBrands.id) {
                ownershipInfo.add('correct-title-vehicle-ownership', ownerString);
                vehicleInfo.add('correct-title-vehicle', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
            } else if (transactionTypeId === this.businessTransactiontType.CancelRegistration.id) {
                ownershipInfo.add('cancel-registration-vehicle-ownership', ownerString);
                vehicleInfo.add('title-registration-vehicle-display', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
            } else if (transactionTypeId === this.businessTransactiontType.DuplicateRegistration.id || transactionTypeId === this.businessTransactiontType.RequestRegistrationCredit.id || transactionTypeId === this.businessTransactiontType.TabReplacement.id || transactionTypeId === this.businessTransactiontType.DuplicatePlate.id || transactionTypeId === this.businessTransactiontType.SuspendRegistration.id) {
                ownershipInfo.add('duplicate-registration-vehicle-ownership', ownerString);
                vehicleInfo.add('title-registration-vehicle-display', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
            } else if (transactionTypeId === this.businessTransactiontType.VehicleMVR.id) {
                ownershipInfo.add('vehicle-mvr-vehicle-ownership', ownerString);
                vehicleInfo.add('title-registration-vehicle-display', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
            } else if (transactionTypeId === this.businessTransactiontType.RenewRegistration.id || transactionTypeId === this.businessTransactiontType.ReinstateRegistration.id) {
                ownershipInfo.add('vehicleownership', ownerString);
                vehicleInfo.add('title-registration-vehicle-fuel-type', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
            } else if (transactionTypeId === this.businessTransactiontType.UpdateRegistration.id) {
                ownershipInfo.add('vehicleownership', ownerString);
                vehicleInfo.add('title-registration-vehicle-fuel-type', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
            } else if (transactionTypeId === this.businessTransactiontType.TnRCorrections.id) {
                ownershipInfo.add('vehicle-ownership-correction', ownerString);
                vehicleInfo.add('title-registration-vehicle', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
            } else if (transactionTypeId === this.businessTransactiontType.Correction.id) {
                ownershipInfo.add('ownership-correction', ownerString);
                vehicleInfo.add('registration-correction', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
                vehicleInfo.add('title-correction', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
            } else {
                ownershipInfo.add('vehicleownership', ownerString);
                vehicleInfo.add('title-registration-vehicle', this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));
            }

            summary.push(ownershipInfo);
            summary.push(vehicleInfo);
        } else if (transactionTypeId === this.businessTransactiontType.IssuePermit.id || transactionTypeId === this.businessTransactiontType.ReprintPermit.id || transactionTypeId === this.businessTransactiontType.CancelPermit.id || transactionTypeId === this.businessTransactiontType.RecreateTRP.id) {
            let permit = null;
            let permitVehicle = null;
            let customerRouteName = '';
            let vehicleRouteName = '';
            if (transactionTypeId === this.businessTransactiontType.IssuePermit.id) {
                if (transactionObject.vehicle.vehiclePermits.length > 0) {
                    permit = transactionObject.vehicle.vehiclePermits.find(c => c.id === 0);
                }

                if (!permit) {
                    permit = transactionObject.vehicle.vehiclePermits[0];
                }

                permitVehicle = transactionObject.vehicle;

                customerRouteName = 'issue-permit-customer';
                vehicleRouteName = 'issue-permit-vehicle';
            } else if (transactionTypeId === this.businessTransactiontType.ReprintPermit.id) {
                permit = transactionObject.vehiclePermit;
                permitVehicle = permit.vehicle;
                customerRouteName = 'duplicate-permit-customer';
                vehicleRouteName = 'duplicate-permit-vehicle';
            } else if (transactionTypeId === this.businessTransactiontType.CancelPermit.id) {
                permit = transactionObject.vehiclePermit;
                permitVehicle = permit.vehicle;
                customerRouteName = 'cancel-permit-customer';
                vehicleRouteName = 'cancel-permit-vehicle';
            } else if (transactionTypeId === this.businessTransactiontType.RecreateTRP.id) {
                permit = transactionObject.vehiclePermit;
                permitVehicle = transactionObject.vehicle;
                vehicleRouteName = 'issue-permit-vehicle';
                customerRouteName = 'issue-permit-customer';
            }

            let ownerString = '';
            let customerName = '';
            let customerAddress = '';
            let city = '';
            let state = '';
            let zipCode = '';
            let dlNumber = 'No DL# Found';

            if (permit) {
                customerName = permit.customer.customerName;
                let address = permit.customer.mailingAddress;
                if (!address) {
                    address = permit.customer.physicalAddress;
                }
                if (!address) {
                    address = permit.customer.customerAddresses[0];
                }

                if (address) {
                    customerAddress = address.addressLine1;
                    city = address.city;
                    if (address.jurisdictionId) {
                        state = this.jurisdiction.FromId(address.jurisdictionId).code;
                    }

                    zipCode = address.postalZipCode;
                }

                if (permit.customer.driversLicenseNumber) {
                    dlNumber = permit.customer.driversLicenseNumber;
                }

                ownerString += this.format(SummaryFormatStrings.VehicleOwnershipFormat, [customerName, dlNumber, customerAddress, city, state, zipCode]);

                ownershipInfo.add(customerRouteName, ownerString);

                summary.push(ownershipInfo);

                if (permitVehicle) {
                    const vin = permitVehicle.vin;
                    const year = permitVehicle.modelYear;
                    const make = permitVehicle.makeDisplayValue;
                    const model = permitVehicle.modelDisplayValue;
                    const plate = '';

                    if (vehiclePlate && vehiclePlate.plate) {
                        // vehiclePlate.plate.plateNumber;
                    }

                    vehicleInfo.add(vehicleRouteName, this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));

                    summary.push(vehicleInfo);
                }
            } else if (transactionObject.vehicle) {
                const vin = transactionObject.vehicle.vin;
                const year = transactionObject.vehicle.modelYear;
                const make = transactionObject.vehicle.makeDisplayValue;
                const model = transactionObject.vehicle.modelDisplayValue;
                const plate = '';

                if (vehiclePlate && vehiclePlate.plate) {
                    // vehiclePlate.plate.plateNumber;
                }

                vehicleInfo.add(vehicleRouteName, this.format(SummaryFormatStrings.VehicleFormat, [vin, year, make, model]));

                summary.push(vehicleInfo);
            }
        } else if (transactionTypeId === this.businessTransactiontType.HomemadeVehiclePermit.id) {
            let permit = null;
            // let permitVehicle = null;
            let customerRouteName = 'issue-permit-homemade-customer';
            let vehicleRouteName = 'issue-permit-homemade-vehicle';
            var transaction = transactionObject as HomemadeVehiclePermitTransactionModel;

            permit = transaction.homemadeVehicle.vehiclePermits.find(c => c.id === 0);
            if (!permit) {
                permit = transaction.homemadeVehicle.vehiclePermits[0];
            }
            let permitVehicle = transaction.homemadeVehicle;

            let ownerString = '';
            let customerName = '';
            let customerAddress = '';
            let city = '';
            let state = '';
            let zipCode = '';
            let dlNumber = 'No DL# Found';

            if (permit) {
                customerName = permit.customer.customerName;
                let address = permit.customer.mailingAddress;
                if (!address) {
                    address = permit.customer.physicalAddress;
                }
                if (!address) {
                    address = permit.customer.customerAddresses[0];
                }
                if (address) {
                    customerAddress = address.addressLine1;
                    city = address.city;
                    if (address.jurisdictionId) {
                        state = this.jurisdiction.FromId(address.jurisdictionId).code;
                    }

                    zipCode = address.postalZipCode;
                }
                if (permit.customer.driversLicenseNumber) {
                    dlNumber = permit.customer.driversLicenseNumber;
                }

                ownerString += this.format(SummaryFormatStrings.VehicleOwnershipFormat, [customerName, dlNumber, customerAddress, city, state, zipCode]);

                ownershipInfo.add(customerRouteName, ownerString);

                summary.push(ownershipInfo);

                if (permitVehicle) {
                    const year = permitVehicle.modelYear;
                    const make = 'HOMEMADE';
                    const model = '';
                    const bodyStyleTypeId = transactionObject.homemadeVehicle.bodyStyleTypeId;
                    vehicleInfo.add(vehicleRouteName, this.format(SummaryFormatStrings.VehicleFormat, [year, make, model, bodyStyleTypeId]));

                    summary.push(vehicleInfo);
                }
            }
        }
        return summary;
    }
}
